// extracted by mini-css-extract-plugin
module.exports = {"container":"AgreeToTermsCheckBox_container__dtdwp","checkbox":"AgreeToTermsCheckBox_checkbox__pQiAL"};